import {SET_URNAME,SET_SECURITYQUESTION} from './types'

const initialState = {
    username:'', //定义初始状态
    securityQuestion:'',
};

export default function authReducer(state = initialState, action){
    switch(action.type){
        case SET_URNAME:
            return {...state,username: action.payload};

        case SET_SECURITYQUESTION:
            return {...state,securityQuestion: action.payload};

        default:
            return state; //别忘了default，很重要，是初始化的关键
    }
}